import { useEffect, useState } from 'react'

export function useLocalState<ST = undefined>(key: string, initial: ST) {
  const [value, setValue] = useState<ST>(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const saved = window.localStorage.getItem(key)
      if (saved) {
        try {
          return JSON.parse(saved)
        } catch {
          // Corrupt stored value (hand-edited, extension, format change):
          // fall back to the initial value rather than crashing the mount.
          return initial
        }
      }
    }
    return initial
  })

  useEffect(() => {
    if (window.localStorage) {
      window.localStorage.setItem(key, JSON.stringify(value))
    }
  }, [value])

  return [value, setValue] as [typeof value, typeof setValue]
}
